export const locatorWidgetTypes = {
  LOCATORWIDGET_ONCHANGE: "LOCATORWIDGET_ONCHANGE",
};
